export const COMMON = `COMMON`;

export const GET_PROVINCE = `${COMMON}/GET_PROVINCE`;
export const GET_DISTRICT = `${COMMON}/GET_DISTRICT`;
export const GET_WARD = `${COMMON}/GET_WARD`;
